export default "__VITE_ASSET__CPc4ojec__"